/** Серия дней: окно и карточка десктопа — представление без стора, всё приходит пропсами. */
import { BoostIcon, Button, Icon, WindowShell, compactCoins } from "../kit";
import { type StreakDayView } from "./model";
import { getLocale } from "../../../i18n";
import { useT } from "../../../app";
import "./styles.css";

export function StreakStrip({ days }: { days: readonly StreakDayView[] }) {
  const t = useT();
  const locale = getLocale();
  return (
    <ol class="win-streak" data-testid="streak-days">
      {days.map((d) => (
        <li
          key={d.day}
          class={`win-day win-day--${d.status}${d.big ? " win-day--big" : ""}`}
          data-status={d.status}
          aria-current={d.status === "today" ? "date" : undefined}
        >
          <span class="win-day__icon">
            {d.big ? <BoostIcon boostId="boost_coin_rush" size={30} /> : <Icon name="coin" size={24} />}
            {d.status === "claimed" && <Icon name="check" size={18} class="win-day__check" />}
          </span>
          <span class="win-day__coins">{compactCoins(d.coins, locale)}</span>
          <span class="win-day__label">{d.big ? t("win.streak.bigBag") : t("win.streak.day", { n: d.day })}</span>
        </li>
      ))}
    </ol>
  );
}

export interface StreakViewProps {
  day: number;
  days: readonly StreakDayView[];
  claimable: boolean;
  onClaim(): void;
  onClose(): void;
}

export function StreakView({ day, days, claimable, onClaim, onClose }: StreakViewProps) {
  const t = useT();
  return (
    <WindowShell kind="streak" title={t("win.streak.title", { n: day })}>
      <StreakStrip days={days} />
      <p class="win-note">{t("win.streak.note")}</p>
      <div class="win-actions">
        {claimable ? (
          <Button tone="green" onClick={onClaim} data-testid="streak-claim">
            {t("win.streak.claim")}
          </Button>
        ) : (
          <Button tone="green" onClick={onClose} data-testid="streak-close">
            {t("win.streak.claimed")}
          </Button>
        )}
      </div>
    </WindowShell>
  );
}

/** Серия карточкой (десктоп, C6): тот же ряд дней, без ленты и затемнения — живёт в правой колонке. */
export function StreakCardView({ day, days, claimable, onClaim }: Omit<StreakViewProps, "onClose">) {
  const t = useT();
  return (
    <section class="win win--card win--streak-card" data-testid="streak-card">
      <h3 class="win-h3">{t("win.streak.title", { n: day })}</h3>
      <StreakStrip days={days} />
      {claimable && (
        <Button tone="green" onClick={onClaim} data-testid="streak-card-claim">
          {t("win.streak.claim")}
        </Button>
      )}
    </section>
  );
}
